import { z } from 'zod';

export enum DigitalCreativesSearchKey {
  SEARCH = 'search',
  CREATIVE_TYPE = 'creativeType',
}

export const digitalCreativesRouterSearchParamsSchema = z.object({
  [DigitalCreativesSearchKey.SEARCH]: z.string().optional(),
  [DigitalCreativesSearchKey.CREATIVE_TYPE]: z.string().optional(),
});
